<template>
  <div>
    <b-loading :active="loading"></b-loading>
    <div class="section has-text-centered" v-if="!loading">
      <p>Thank you for creating and setting up your account with AWG. Please select the application below that you wish to log in to.</p>
      <div class="columns is-desktop">
        <div v-if="HasCTCRole" class="column has-text-centered" style="margin-top:60px;">
          <figure class="image" style="display:inline-block; max-width:50%">
            <img src="../assets/images/ctcOnly-logo-2-10-2020.png" />
          </figure>
          <div>
            <b-button type="is-info" @click="Goto('CTC')">Login CTC Compliance Index</b-button>
          </div>
        </div>
        <div v-if="HasCCRole" class="column has-text-centered">
          <figure class="image is-128x128" style="display:inline-block; max-width:50%">
            <img src="../assets/images/CC-Logo.png" />
          </figure>
          <div>
            <b-button type="is-info" @click="Goto('CC')">Login Carbon Calculator</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        loading: true,
        ctcRoles: undefined,
        ccRoles: undefined,
        userRoles: undefined
      }
    },
    computed: {
      HasCTCRole() {
        if (this.$store.getters.isLoggedIn) {
          return this.ctcRoles.some(x => this.$store.getters.user.Roles.some(y => x === y));
        }
        else if (this.userRoles) {
          return this.ctcRoles.some(x => this.userRoles.some(y => x === y));
        }
        else
          false;
      },
      HasCCRole() {
        if (this.$store.getters.isLoggedIn) {
          return this.ccRoles.some(x => this.$store.getters.user.Roles.some(y => x === y));
        }
        else if (this.userRoles) {
          return this.ccRoles.some(x => this.userRoles.some(y => x === y));
        }
        else
          false;
      }
    },
    methods: {
      async GetCTCRoles() {
        try {
          var response = await this.$http.get("/api/roles/ctc");
          this.ctcRoles = response.data.map(x => x.Id);
          return response;
        }
        catch (err) {
          console.error(err);
          return Promise.reject();
        }
      },
      async GetCCRoles() {
        try {
          var response = await this.$http.get("/api/roles/cc");
          this.ccRoles = response.data.map(x => x.Id);
          return response;
        }
        catch (err) {
          console.error(err);
          return Promise.reject();
        }
      },
      async GetUserRolesByEmail(email) {
        try {
          var response = await this.$http.get("api/roles/by/email/" + this.$route.params.email);
          this.userRoles = response.data.map(x => x.Id);
          return response;
        }
        catch (err) {
          console.error(err);
          return Promise.reject();
        }
      },
      Goto(id) {
        switch (id) {
          case "CTC": {
            this.$router.push({ name: "login" });
            break;
          }
          case "CC": {
            location.href = this.$CCURL + "/login";
            break;
          }
        }
      },
      TryRedirect() {
        if (this.HasCTCRole == true && this.HasCCRole == true)
          return;
        else if (this.HasCTCRole == true && this.HasCCRole == false) {
          this.Goto("CTC");
        }
        else if (this.HasCTCRole == false && this.HasCCRole == true) {
          this.Goto("CC");
        }
        else {
          this.Goto("CTC");
        }
      }
    },
    async created() {
      if (this.$route.params.email) {
        await this.GetUserRolesByEmail(this.$route.params.email);
      }

      await Promise.all([this.GetCTCRoles(), this.GetCCRoles()]);
      //this.TryRedirect();
      this.loading = false;
    }
  }
</script>
